import gql from 'graphql-tag';

import {fragments as detailsFragments} from '../Details/Details';
import {fragments as geoDistanceFragments} from '../GeoDistance/GeoDistance';
import {fragments as priceFragments} from '../Price/Price';
import {fragments as ratingFragments} from '../Rating/Rating';

export const hitInfoDesktopFragments = {
    Listing: gql`
        fragment HitInfoDesktopListing on Listing {
            detailPageUrl
            instantBookable
            minStayRange {
                minStayHigh
                minStayLow
            }
            listingId
            listingNumber
            rankedBadges(rankingStrategy: SERP) {
                id
                helpText
                name
            }
            propertyId
            propertyMetadata {
                headline
            }
            superlativesBadges: rankedBadges(
                rankingStrategy: SERP_SUPERLATIVES
            ) {
                id
                helpText
                name
            }
            unitMetadata {
                unitName
            }
            webRatingBadges: rankedBadges(rankingStrategy: SRP_WEB_RATING) {
                id
                helpText
                name
            }
            ...DetailsListing
            ...GeoDistanceListing
            ...PriceListing
            ...RatingListing
        }
        ${detailsFragments.Listing}
        ${geoDistanceFragments.Listing}
        ${priceFragments.Listing}
        ${ratingFragments.Listing}
    `
};
